import {TRANSACTIONAL_ITEMS_API_HOST} from '../../constants/app';
import getMemberToken from '../../utils/getMemberToken';
import {wishlistCreated} from '../../analytics';

const getHeaders = () => ({
  'MEMBERSHIP-SESSION-TOKEN': getMemberToken(),
  Accept: 'application/json',
  'Content-Type': 'application/json',
});

const validateRequired = (fields, fnName) =>
  Object.entries(fields).forEach(([key, value]) => {
    if (!value) {
      throw new Error(`${fnName} requires a "${key}"`);
    }
  });

const checkError = (res, jsonResponse) => {
  if (!res.ok) {
    const error = new Error(jsonResponse.message || res.statusText);
    error.status = res.status;
    error.response = jsonResponse.message;
    throw error;
  }
};

const TransactionalItemApi = {
  addRegistryItem: async ({memberId, item}) => {
    const res = await fetch(
      `${TRANSACTIONAL_ITEMS_API_HOST}/registry/${memberId}/items`,
      {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(item),
      },
    );

    const isCreatingWishlist = res.headers.get('wishlist-created') === 'true';

    if (isCreatingWishlist) {
      wishlistCreated({
        wishlist_id: memberId,
        wishlist_name: 'Transactional Registry',
      });
    }

    const jsonResponse = await res.json();

    checkError(res, jsonResponse);

    return jsonResponse;
  },

  getItems: async ({memberId}) => {
    const res = await fetch(
      `${TRANSACTIONAL_ITEMS_API_HOST}/registry/${memberId}/items`,
      {
        method: 'GET',
        headers: getHeaders(),
      },
    );

    const jsonResponse = await res.json();

    checkError(res, jsonResponse);

    return jsonResponse;
  },

  updateRegistryItem: async ({memberId, sku, item}) => {
    const res = await fetch(
      `${TRANSACTIONAL_ITEMS_API_HOST}/registry/${memberId}/items/${sku}`,
      {
        method: 'PUT',
        headers: getHeaders(),
        body: JSON.stringify(item),
      },
    );

    const jsonResponse = await res.json();

    checkError(res, jsonResponse);

    return jsonResponse;
  },

  updateGCItem: async ({memberId, sku, item}) => {
    const res = await fetch(
      `${TRANSACTIONAL_ITEMS_API_HOST}/registry/${memberId}/gift-cards/${sku}`,
      {
        method: 'PUT',
        headers: getHeaders(),
        body: JSON.stringify(item),
      },
    );

    if (!res.ok) {
      const error = new Error(res.statusText);
      error.status = res.status;
      throw error;
    }

    const jsonResponse = await res.json();

    return jsonResponse;
  },

  deleteRegistryItem: async ({memberId, itemId}) => {
    validateRequired(
      {memberId, itemId},
      'TransactionalItemApi.deleteRegistryItem',
    );

    const res = await fetch(
      `${TRANSACTIONAL_ITEMS_API_HOST}/registry/${memberId}/items/${itemId}`,
      {
        method: 'DELETE',
        headers: getHeaders(),
      },
    );

    if (!res.ok) {
      const error = new Error(res.statusText);
      error.status = res.status;
      throw error;
    }
  },
};

export default TransactionalItemApi;
